import React from "react";

// context
import { usePhotoModBatches } from "frontend/components/fort/mod/photos/hooks/usePhotoModBatches";
import { BATCH_TYPES } from "frontend/components/fort/mod/photos/constants.js";

// components
import CheckboxGroup from "core/CheckboxGroup";

// component
export const FilterByBatchType = () => {
    const {
        setBatchTypeFilter,
        filters: { batchType },
        isCallingApi
    } = usePhotoModBatches();

    const onFilterToggle = (isCheckedInverse, e) => {
        const filterId = e.target.value;
        setBatchTypeFilter({
            [filterId]: isCheckedInverse
        });
    };

    const checkboxes = BATCH_TYPES.map(batchTypeObj => {
        const { id, label, key } = batchTypeObj;
        return {
            id,
            label,
            inputValue: key,
            isChecked: !!batchType[key], //null and false are false, true is true
            isDisabled: isCallingApi
        };
    });
    return (
        <div id="filter-by-batch-type" data-testid="filter-by-batch-type">
            <CheckboxGroup
                legend="Filter by Batch Type"
                onClick={onFilterToggle}
                checkboxes={checkboxes}
            />
        </div>
    );
};

export default FilterByBatchType;
